/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  createContext,
  useContext,
} from 'react';
import { css, jsx } from '@emotion/core';
import useSetState from 'hooks/useSetState';

import { interactionContext } from './interactionContext';

import Id_ from './Message';
import collectFeedbackSubmitted from 'assets/collectFeedbackSubmitted.svg';
import { useDispatch } from 'react-redux';

const FiveStarRatingContext = createContext<any>(undefined);

const FeedbackSubmitted = () => {
  return (
    <div
      className="fader_-5s"
      css={css`
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      `}
    >
      <img src={collectFeedbackSubmitted} />
      <div
        css={css`
          margin: 50px 0 0 0;
          font-size: 18px;
          text-align: center;
        `}
        role="alert"
      >
        Thanks! Your feedback has been submitted.
      </div>
    </div>
  );
};

const FiveStarRating = props => {
  const { children, onSubmit = () => { } } = props;
  let [FiveStarList, Message, SubmitBtn] = children;

  const {
    useMyFeedbackApp = 0,
    emailRequired = 1,
    emailOptional = 0,
    anonymityRequired = 0,
    identityPlaceholder,
    include5StarRating = true,
    reference = '',
    collectionKey = '',
  } = useContext(interactionContext).props;

  //
  const {
    state: { rating, learnerIdentity, message },
    setState,
  } = useSetState({
    rating: null,
    learnerIdentity: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);

  let hasLearnerIdentity = learnerIdentity !== '';

  const dispatch = useDispatch();

  const Id =
    !!useMyFeedbackApp && (!!emailRequired || !!emailOptional) ? (
      <Id_
        placeholder={identityPlaceholder || 'Enter your id'}
        onUpdateCallback="onUpdateLearnerIdentity"
        style={{ height: 45, margin: '0 0 10px 0', overflow: 'hidden' }}
      />
    ) : null;

  Message = React.cloneElement(Message, {
    onUpdateCallback: 'onUpdateMessage',
    style: {
      minHeight: 150,
      margin: '10px 0 30px 0',
    },
  });

  return (
    <FiveStarRatingContext.Provider
      value={{
        rating,
        message,
        hasLearnerIdentity,
        learnerIdentity,
        include5StarRating,
        onSubmit() {
          setSubmitted(true);
          onSubmit();
          dispatch({
            type: "SUBMIT_FEEDBACK", data: {
              key: collectionKey,
              rating: rating + 1,
              message,
              identity: learnerIdentity,
              reference,
            }
          })
        },
        alertLearnerIdentity() {
        },
        onUpdateRating(index) {
          setState({ rating: index === rating ? null : index });
        },
        onUpdateLearnerIdentity(learnerIdentity) {
          setState({ learnerIdentity });
        },
        onUpdateMessage(message) {
          setState({ message });
        },
      }}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          position: relative;
          width: 100%;
          height: 100%;
        `}
      >
        {!submitted && (
          <div
            css={css`
            width: 100%;
            height: 100%;
            opacity: 1;
            ${submitted &&
              `
            opacity: 0;
            transition: opacity 0.3s;
            `}
          `}
          >
            {include5StarRating && FiveStarList}
            {Id}
            {Message}
            {SubmitBtn}
          </div>
        )}

        {submitted && (
          <div
            css={css`
            width: 100%;
            height: 100%;
            min-height: 500px;
            `}
          />
        )}

        {submitted && <FeedbackSubmitted />}
      </div>
    </FiveStarRatingContext.Provider>
  );
};

export default FiveStarRating;
export { FiveStarRatingContext };
